import { render } from "./login.vue?vue&type=template&id=5376a2aa&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=5376a2aa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5376a2aa"

export default script